import React from 'react';

/**
 * SectionCompaniaArt - Componente modular para la selección de Aseguradora y Códigos.
 * Sincronizado directamente con el manejador de eventos unificado para cambios encadenados instantáneos.
 */
const SectionCompaniaArt = ({ state, actions }) => {
    const { formData, dbMasters, companiaLists } = state;
    const { handleChange } = actions;

    return (
        <fieldset className="border border-slate-200 rounded-xl p-6 bg-white shadow-sm text-left animate-fade-in transition-all duration-300">
            <legend className="px-3 text-base font-bold text-slate-700 tracking-tight">Datos de la Compañía</legend>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 pt-2">
                
                {/* SELECCIÓN DE COMPAÑÍA */}
                <div>
                    <label className="label-form text-slate-600 font-bold mb-1 block">Compañía Aseguradora *</label>
                    <select 
                        name="compania" 
                        value={formData.compania || ''} 
                        onChange={handleChange} 
                        className="input-round font-bold border-slate-200 focus:border-indigo-500 w-full rounded-xl px-4 py-2.5 h-[46px] outline-none border transition-all focus:ring-1 focus:ring-indigo-100" 
                        required
                    >
                        <option value="">Seleccione Cía...</option>
                        {dbMasters.companias.map(c => (
                            <option key={c.id} value={c.nombre}>{c.nombre}</option>
                        ))}
                    </select>
                </div>

                {/* CÓDIGO ORGANIZADOR (DEPENDIENTE) */}
                <div>
                    <label className="label-form text-slate-600 font-bold mb-1 block">Código Organizador</label>
                    <select 
                        name="organizador" 
                        value={formData.organizador || ''} 
                        onChange={handleChange} 
                        className={`input-round font-bold border-slate-200 w-full rounded-xl px-4 py-2.5 h-[46px] outline-none border transition-all focus:border-indigo-500 focus:ring-1 focus:ring-indigo-100 ${
                            companiaLists.organizadores.length === 0 ? 'bg-slate-50/50 text-slate-400 opacity-60 cursor-not-allowed' : 'bg-white text-slate-700'
                        }`}
                        disabled={companiaLists.organizadores.length === 0}
                    >
                        <option value="">{companiaLists.organizadores.length === 0 ? 'Sin códigos...' : 'Seleccione código...'}</option>
                        {companiaLists.organizadores.map((o, idx) => (
                            <option key={idx} value={o}>{o}</option>
                        ))}
                    </select>
                </div>

                {/* CÓDIGO PAS (DEPENDIENTE) */}
                <div>
                    <label className="label-form text-slate-600 font-bold mb-1 block">Código PAS</label>
                    <select 
                        name="pas" 
                        value={formData.pas || ''} 
                        onChange={handleChange} 
                        className={`input-round font-bold border-slate-200 w-full rounded-xl px-4 py-2.5 h-[46px] outline-none border transition-all focus:border-indigo-500 focus:ring-1 focus:ring-indigo-100 ${
                            companiaLists.productores.length === 0 ? 'bg-slate-50/50 text-slate-400 opacity-60 cursor-not-allowed' : 'bg-white text-slate-700'
                        }`}
                        disabled={companiaLists.productores.length === 0}
                    >
                        <option value="">{companiaLists.productores.length === 0 ? 'Sin códigos...' : 'Seleccione código...'}</option>
                        {companiaLists.productores.map((p, idx) => (
                            <option key={idx} value={p}>{p}</option>
                        ))}
                    </select>
                </div>
            </div>
        </fieldset>
    );
};

export default SectionCompaniaArt;